import { Component } from '@angular/core';
import { BreadcrumbComponent } from '../../shared/breadcrumb/breadcrumb.component';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-register',
    imports: [BreadcrumbComponent, FormsModule, RouterLink],
    templateUrl: './register.component.html',
    styleUrl: './register.component.css'
})
export class RegisterComponent {
  constructor(private api:ApiService){}
  currentBreadcrumb= ['Account','Log In']
  register = {
    firstName: "",
    lastName: "",
    companyName: "",
    email: "",
    password: "",
    phoneNumber: ""
  }

  async signUp(){
    let res = await this.api.register(this.register)
  }
}
